import { useTranslation } from "react-i18next";

import type { ZipLookupStatus } from "./useZipAutofill";

interface ZipLookupMessageProperties {
  status: ZipLookupStatus;
}

// Renders the not-found / lookup-error alert shown under a ZIP field, and
// nothing for idle / loading / successful lookups. Shared by every address
// block that drives autofill via useZipAutofill so the status -> copy mapping
// lives in one place.
export function ZipLookupMessage({ status }: ZipLookupMessageProperties) {
  const { t } = useTranslation();
  if (status !== "not-found" && status !== "error") {
    return null;
  }
  return (
    <p role="alert" className="text-destructive text-2xs mt-1">
      {t(status === "not-found" ? "review.zip.notFound" : "review.zip.lookupError")}
    </p>
  );
}
